import { animate, keyframes, query, state, style, transition, trigger, group } from "@angular/animations"

// Showhide height wise
export const showHide = trigger('showHide', [
  transition(':enter', [
    style({
      overflow: 'hidden',
      height: '0px',
      transform: 'translateY(-100%)',
      opacity: 0
    }),
    animate('500ms', style({
      overflow: 'hidden',
      height: '*',
      transform: 'translateY(0)',
      opacity: 1
    })),
  ]),
  transition(':leave',
    [animate('500ms',
      style({
        overflow: 'hidden',
        height: '0px',
        transform: 'translateY(-100%)',
        opacity: 0
      }))]),
]);

// Showhide width wise
export const widthAni = trigger('widthAni', [
  transition(':enter', [
    style({
      overflow: 'hidden',
      width: '0px',
      // height: '0px',
      // transform: 'translateX(-100%)',
      opacity: 0
    }),
    animate('500ms', style({
      overflow: 'hidden',
      width: '*',
      // height: '*',
      // transform: 'translateX(0)',
      opacity: 1
    })),
  ]),
  transition(':leave',
    [animate('500ms',
      style({
        overflow: 'hidden',
        width: '0px',
        // height: '0px',        
        // transform: 'translateX(-100%)',
        opacity: 0
      }))]),
]);


// Experimental....
export const showHidetrigger = trigger('showHidetrigger', [
  state('open', style({
    height: '200px',
    opacity: 1,
    backgroundColor: 'yellow'
  })),
  state('closed', style({
    height: '100px',
    opacity: 0.8,
    backgroundColor: 'blue'
  })),
  transition('* => closed', [
    animate('1s')
  ]),
  transition('* => open', [
    animate('0.5s')
  ]),
]);

export const bounce = trigger('bounce', [
  state('initial', style({ transform: 'scale(0,0) translateY(0)' })),
  state('active', style({ transform: 'scale(1,1) translateY(20px)' })),
  transition('* <=> *', [
    animate('2s', keyframes([
      style({ transform: 'scale(1,1) translateY(0)' }),
      style({ transform: 'scale(1.1, 0.9) translateY(0)' }),
      style({ transform: 'scale(0.9, 1.1) translateY(-100px)' }),
      style({ transform: 'scale(1.05, 0.95) translateY(0)' }),
      style({ transform: 'scale(1,1) translateY(-7px)' }),
      style({ transform: 'scale(1,1) translateY(0)' }),
    ]))
  ])
]);

export const slideAnimation = trigger('slideAnimation', [
  transition(':increment', group([
    query(':enter', [
      style({
        transform: 'translateX(100%)',
        opacity: 0
      }),
      animate('0.5s ease-out', style({
        transform: 'translateX(0)',
        opacity: 1
      }))
    ]),
    query(':leave', [
      animate('0.5s ease-out', style({
        transform: 'translateX(-100%)',
        opacity: 0
      }))
    ])
  ])),
  transition(':decrement', group([
    query(':enter', [
      style({
        transform: 'translateX(-100%)',
        opacity: 0
      }),
      animate('0.5s ease-out', style({
        transform: 'translateX(0)',
        opacity: 1
      }))
    ]),
    query(':leave', [
      animate('0.5s ease-out', style({
        transform: 'translateX(100%)',
        opacity: 0
      }))
    ])
  ]))
]);

// trigger('showHidetrigger', [
//     state('collapsed', style({ height: '0', opacity: 0 })),
//     state('expanded', style({ height: '*', opacity: 1 })),
//     transition('collapsed <=> expanded', [
//         animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')
//     ]),
// ]);
// trigger('showHideTrigger', [
//     transition('* <=> *', [
//         query(':enter', [
//             style({ height: 0, overflow: 'hidden' }),
//             animate('500ms', style({ height: '*', overflow: 'unset' }))
//         ], { optional: true }),
//         query(':leave', [
//             style({ overflow: 'hidden' }),
//             animate('500ms', style({ height: 0 }))
//         ], { optional: true }),
//     ]),
// ]);

// trigger('showHideTrigger', [
//     state('out', style({
//         overflow: 'hidden',
//         height: '*',
//         transform: 'translateY(0)',
//         opacity: 1
//     })),
//     state('in', style({
//         overflow: 'hidden',
//         height: '0px',
//         transform: 'translateY(-100%)',
//         opacity: 0
//     })),
//     transition('in => out', animate('500ms ease-in-out')),
//     transition('out => in', animate('500ms ease-in-out')),

// ]);

// trigger(
//   'inOutAnimation',
//   [state('open', style({
//     width: '100%',
//     opacity: 1,
//   })),
//   state('closed', style({
//     width: '0',
//     opacity: 0,
//   })),
//   transition('* => closed', [
//     animate('1s')
//   ]),
//   transition('* => open', [
//     animate('1s')
//   ]),]